<template>
  <div>
    <v-card>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>Evaluacion de Desempeño</v-toolbar-title>
    </v-toolbar>
    
<v-stepper value="1" alt-labels>
    <v-stepper-header>
        <v-stepper-step step="1">Fujo de Objetivos</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" complete>Revision y Aprobacion de Objetivos</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">Revision de Objetivos de Medio Año</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4">Evaluacion Final del Trabajador</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
        <v-stepper-content step="1">
            <v-tabs>
                <v-tab align-with-title="true">
                    <v-icon left>mdi-elevation-rise</v-icon>
                    Competencias
                </v-tab>
                <v-tab style="align-content: flex-start;">
                    <v-icon left>mdi-code-equal</v-icon>
                    Objetivos
                </v-tab>

                <v-tab-item>
                    <v-card flat>
                        <v-card-subtitle>
                         <v-btn
                            absolute
                            dark
                            fab
                            top
                            right
                            color="success"
                            @click="dialog = true"
                            >
                        <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        </v-card-subtitle>
                        <v-card-text>
                            <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th class="text-left">Competencia</th>
                                    <th class="text-left">Peso %</th>
                                    <th class="text-left">Inicio</th>
                                    <th class="text-left">Fin</th>
                                    <th class="text-left">Estado</th>
                                    <th class="text-left"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Competencia 1</td>
                                    <td>30%</td>
                                    <td>01/01/2020</td>
                                    <td>30/06/2020</td>
                                    <td>Iniciado</td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </template>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab-item>
                    <v-card flat>
                        <v-card-subtitle>
                         <v-btn
                            absolute
                            dark
                            fab
                            top
                            right
                            color="success"
                            @click="dialog = true"
                            >
                        <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        </v-card-subtitle>
                        <v-card-text>
                            <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th class="text-left">Objetivos</th>
                                    <th class="text-left">Peso %</th>
                                    <th class="text-left">Inicio</th>
                                    <th class="text-left">Fin</th>
                                    <th class="text-left">Estado</th>
                                    <th class="text-left"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Objetivo 1</td>
                                    <td>90%</td>
                                    <td>01/01/2020</td>
                                    <td>30/06/2020</td>
                                    <td>No Iniciado</td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </template>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>
                </v-tab-item>


            </v-tabs>
        </v-stepper-content>
    </v-stepper-items>
</v-stepper>
  </v-card>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Agregar Objetivo</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field label="Nombre del Objetivo*" required outlined></v-text-field>
              </v-col>
              <v-col cols="12">
                    <v-textarea outlined name="input-7-4" label="Descripcion del Objetivo*" rows="2"></v-textarea>
              </v-col>
              <v-col cols="12">
                    <v-textarea outlined name="input-7-4" label="Criterios de Exito" rows="2"></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea outlined name="input-7-4" label="Resultados" rows="2"></v-textarea>
              </v-col>
              <v-col cols="4">
                <v-text-field label="% Peso" required outlined value="0,0"></v-text-field>
              </v-col>
              <v-col cols="8">
                <v-select
                  :items="['No Iniciado', 'Iniciado', 'Detenido']"
                  label="Estatus*"
                  outlined
                  required
                ></v-select>
              </v-col>
              <v-col cols="6">
                          Inicio*
                          <v-menu
                            ref="inicio"
                            v-model="inicio"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="date1"
                                persistent-hint
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="date1" no-title @input="inicio = false"></v-date-picker>
                          </v-menu>
              </v-col>
              <v-col cols="6">
                          Final*
                          <v-menu
                            ref="final"
                            v-model="fin"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="date2"
                                persistent-hint
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="date2" no-title @input="fin = false"></v-date-picker>
                          </v-menu>
              </v-col>

            </v-row>
          </v-container>
          <small>*Los campos marcados son requeridos</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="dialog = false">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'desempeno',
  data:()=>({
    slider:100,
    primero:50,
    segundo:50,
    dialog: false,
    date1: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    inicio: false,
    fin: false
  }),computed: {
    elprimero(){
      this.segundo = this.slider - this.primero;
      return this.primero;
    },
    elsegundo(){
      this.primero = this.slider - this.segundo;
      return this.segundo;
    }
  },
  
}
</script>
<style scoped>

</style>